import React, { useState } from 'react';
import styled from "styled-components";
import { Button, Input} from "../../../ui/ot";
import Title from 'antd/es/skeleton/Title';
import { useNavigate } from "react-router-dom";
import CirculationPlace from './CirculationPlace';
// Sample data based on your screenshot
const books = [
  {
    result: {
      title: '零基礎炒飯66道 : 超詳盡炒飯攻略 炒飯清爽少油的秘密!',
      author: '陽光超人',
      materialType: 'Text',
      format: 'print',
      literaryForm: 'Not fiction',
      audience: 'Adult',
      series: 'Cooking ; 18',
      publicationDetails: '新北市 : 優品文化出版 : 大和總經銷, 2023[民112]',
      description: '171面 : 彩圖, 彩像 ; 26公分.',
      isbn: '9789865481421',
      edition: '[一版]',
      otherTitle: '超詳盡炒飯攻略 炒飯清爽少油的秘密 | 超詳盡炒飯攻略 炒飯清爽少油的秘密 | 零基礎炒飯六十六道'
    },
    imageUrl: 'https://via.placeholder.com/100', // Placeholder image URL
    availability: [
      { location: '巨籌校區', callNumber: '427.35', status: 'Available', dueDate: null },
      { location: '介壽校區', callNumber: '427.35', status: 'Available', dueDate: null },
      { location: '介壽校區', callNumber: '427.35', status: 'Checked out', dueDate: '07/17/2024' },
      { location: '介壽校區', callNumber: '427.35', status: 'On hold', dueDate: null },
    ],
  },
];

const CirculationBookList = () => {
  const handleAddToCart = (bookTitle) => {
    alert(`Adding "${bookTitle}" to cart`);
  };

  const handleAddToList = (bookTitle) => {
    alert(`Adding "${bookTitle}" to list`);
  };
  
  const navigate = useNavigate();
  const [checkboxState,setCheckboxState] = useState({
        checkbox1 :false
    })
  const handlePlaceHold = (book) => {
    const {checkbox1} = checkboxState
    if(!checkbox1){
        alert(`NO Select`)
    }else{
        console.log(book)
        alert(`book :`,book)
        navigate(`../CirculationReserve`,{state:{title:book}});
    }
};
const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState(prevState => ({
      ...prevState,
      [name]: checked
    }));
  };
  return (
    <MainContainer>
      <div>
        <Title>Library Book List</Title>
        {books.map((book, index) => (
          <BookContainer key={index}>
            <ButtonGroup>
              <Button type="button" onClick={() => handleAddToCart(book.result.title)}>Add to cart</Button>
              <Button type="button" onClick={() => handleAddToList(book.result.title)}>Add to list</Button>
              <Button type="button" onClick={() => handlePlaceHold(book.result.title)}>Place hold</Button>
            </ButtonGroup>
            <WhiteBox>
              <BookDetails>
                <Table>
                  <thead>
                    <tr>
                      <th>IMG</th>
                      <th>Select</th>
                      <th>Results</th>
                      <th>Availability</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <img src={book.imageUrl} alt="Book cover" />
                      </td>
                      <td>
                        <Input
                        type="checkbox"
                        name="checkbox1"
                        checked={checkboxState.checkbox1}
                        onChange={handleCheckboxChange}
                        />
                      </td>
                      <td>
                        <div><strong>Title:</strong> {book.result.title}</div>
                        <div><strong>Author:</strong> {book.result.author}</div>
                        <div><strong>Material Type:</strong> {book.result.materialType}</div>
                        <div><strong>Format:</strong> {book.result.format}</div>
                        <div><strong>Literary Form:</strong> {book.result.literaryForm}</div>
                        <div><strong>Audience:</strong> {book.result.audience}</div>
                        <div><strong>Series:</strong> {book.result.series}</div>
                        <div><strong>Publication Details:</strong> {book.result.publicationDetails}</div>
                        <div><strong>Description:</strong> {book.result.description}</div>
                        <div><strong>ISBN:</strong> {book.result.isbn}</div>
                        <div><strong>Edition:</strong> {book.result.edition}</div>
                        <div><strong>Other Title:</strong> {book.result.otherTitle}</div>
                      </td>
                      <td>
                        <AvailabilityList>
                          {book.availability.map((availability, idx) => (
                            <li key={idx}>
                              <strong>Location:</strong> {availability.location}<br />
                              <strong>Call Number:</strong> {availability.callNumber}<br />
                              <StatusText status={availability.status}><strong>Status:</strong> {availability.status}</StatusText><br />
                              <strong>Due Date:</strong> {availability.dueDate || 'N/A'}
                            </li>
                          ))}
                        </AvailabilityList>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </BookDetails>
            </WhiteBox>
            <hr style={{ margin: '10px 0' }} />
          </BookContainer>
        ))}
      </div>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  align-items: start;
  gap: 0.5em;
`;

const BookContainer = styled.div`
  border: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 10px;
`;

const WhiteBox = styled.div`
  background-color: #fff;
  padding: 1em;
  width: -webkit-fill-available;
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  gap: 1em;
  align-items: flex-start;
`;

const BookDetails = styled.div`
  h2 {
    margin: 0;
  }

  p {
    margin: 5px 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;

  td, th {
    padding: 0.5em;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f5f5f5;
  }

  td:first-child {
    font-weight: bold;
    width: 20%;
  }
`;

const AvailabilityList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const StatusText = styled.span`
  color: ${({ status }) => (status === 'Available' ? 'green' : status === 'Checked out' ? 'red' : 'black')};
`;
export default CirculationBookList;
